document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});
// document.addEventListener("teeinblue-event-component-injected", function () {
//   if (window.matchMedia("(max-width: 768px)").matches) {
//     const elementToMove = document.querySelector("#teeAtcButton");
//     const insertAfterElement = document.querySelector(
//       ".teeinblue-enabled .product-header__info"
//     );
//     if (elementToMove && insertAfterElement) {
//       insertAfterElement.after(elementToMove);
//     }
//   }
// });
